import { render, staticRenderFns } from "./ProductInfoThumbnail.vue?vue&type=template&id=52fd4260&scoped=true&"
import script from "./ProductInfoThumbnail.vue?vue&type=script&lang=js&"
export * from "./ProductInfoThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoThumbnail.vue?vue&type=style&index=0&id=52fd4260&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fd4260",
  null
  
)

export default component.exports